export const PAGE_PERFORMANCE_ICON = {
    OPEN: 'fas fa-chevron-down',
    CLOSE: 'fas fa-chevron-right',
} as const;
